import script from "./sport-live-tv-event-card.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-event-card.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-event-card.vue?vue&type=style&index=0&id=c85fefe0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c85fefe0"]])

export default __exports__